import React from "react";

import { useState, useEffect } from "react";
import { Card, Button } from "react-bootstrap";
import {
  FaEdit,
  FaExchangeAlt,
  FaSyncAlt,
  FaTrash,
  FaBus,
  FaUser,
  FaClock,
  FaRoute,
} from "react-icons/fa";
import { MdOutlineMail } from "react-icons/md";
import Edittripmodal from "./Edittripmodal";
import { renderTripDuration } from "../../../utilities";
import ReplaceBusModal from "./ReplaceBusModal";
import ReplaceDriverModal from "./ReplaceDriverModal";
import Edittriptime from "./EditTriptime";
const parseTime = (timeStr) => {
  if (!timeStr) return null;
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  const now = new Date();
  now.setHours(hours, minutes, seconds || 0, 0);
  return now;
};
const Tripdetails = ({
  routeName,
  routeId,
  data,
  endtime,
  handleListReload,
}) => {
  const [modalopen, setModalopen] = useState(false);
  const [replaceBusModal, setReplaceBusModal] = useState(false);
  const [replaceDriverModal, setReplaceDriverModal] = useState(false);
  return (
    <div>
      <Card className="border-0">
        <Card.Body className="pt-1">
          <div className="d-flex flex-column gap-2">
            <div className="d-flex align-items-center">
              <FaRoute className="me-2 text-primary" />
              <span className="fw-semibold text-primary">Route:</span>
              <span
                className="ms-2 text-secondary"
                style={{ fontWeight: "500" }}
              >
                {routeName || "N/A"}
              </span>
            </div>

            <div className="d-flex align-items-center">
              <FaClock className="me-2 text-warning" />
              <span className="fw-semibold text-primary">Shift:</span>
              <span
                className="ms-2 text-secondary"
                style={{ fontWeight: "500" }}
              >
                {data?.shift?.name || "N/A"}
              </span>
            </div>

            <div className="d-flex align-items-center">
              <FaBus className="me-2 text-info" />
              <span className="fw-semibold text-primary">Bus Number:</span>
              <span
                className="ms-2 text-secondary"
                style={{ fontWeight: "500" }}
              >
                {data?.bus?.number_plate || "N/A"}
              </span>
            </div>

            <div className="d-flex align-items-center">
              <FaUser className="me-2 text-success" />
              <span className="fw-semibold text-primary">Driver:</span>
              <span
                className="ms-2 text-secondary"
                style={{ fontWeight: "500" }}
              >
                {data?.driver?.name || "N/A"}
              </span>
            </div>

            <div className="d-flex align-items-center">
              <MdOutlineMail className="me-2 text-info" />
              <span className="fw-semibold text-primary">Email:</span>
              <span
                className="ms-2 text-secondary"
                style={{ fontWeight: "500" }}
              >
                {data?.driver?.email || "N/A"}
              </span>
            </div>

            <div className="d-flex align-items-center">
              <FaClock className="me-2 text-secondary" />
              <span className="fw-semibold text-primary">Trip Duration:</span>
              <span className="ms-2">
                {data?.start_time && data?.end_time
                  ? renderTripDuration(
                      parseTime(data.start_time),
                      parseTime(data.end_time)
                    )
                  : "N/A"}
              </span>
            </div>

            <div className="d-flex align-items-center">
              <FaUser className="me-2 text-dark" />
              <span className="fw-semibold text-primary">Total Passes:</span>
              <span
                className="ms-2 text-secondary"
                style={{ fontWeight: "500" }}
              >
                {data?.total_pass || "0"}
              </span>
            </div>

            <div className="d-flex align-items-center">
              <FaExchangeAlt className="me-2 text-dark" />
              <span className="fw-semibold text-primary">Trip mode:</span>

              <span
                className={`ms-2 badge  ${
                  data?.trip_mode?.toLowerCase() === "pickup"
                    ? "text-bg-success-soft"
                    : "text-bg-info-soft"
                }`}
                style={{ fontWeight: "500" }}
              >
                {data?.trip_mode || "N/A"}
              </span>
            </div>
          </div>
        </Card.Body>

        <Card.Footer className="bg-white d-flex justify-content-between">
          {/* <Button
            variant="outline-primary"
            size="sm"
            onClick={() => setReplaceBusModal(true)}
          >
            Replace Bus
          </Button> */}
          <Button
            variant="outline-info"
            size="sm"
            onClick={() => setReplaceDriverModal(true)}
          >
            {/* <FaExchangeAlt className="me-1" /> */}
            Replace Driver
          </Button>
          <Button
            variant="outline-warning"
            size="sm"
            onClick={() => setModalopen(true)}
          >
            {/* <FaEdit className="me-1" /> */}
            Change Time
          </Button>
            <Button
            variant="outline-danger"
            size="sm"
          >
            {/* <FaEdit className="me-1" /> */}
            Cancel Trip
          </Button>
        </Card.Footer>
      </Card>
      <Edittriptime
        modalopen={modalopen}
        setModalopen={setModalopen}
        routeid={routeId}
        tripdata={data}
        end_time={endtime}
        handleListReload={handleListReload}
      />
      {/* <ReplaceBusModal
        modalopen={replaceBusModal}
        setModalopen={setReplaceBusModal}
        routeid={routeId}
        tripdata={data}
        end_time={endtime}
        handleListReload={handleListReload}
      /> */}
      <ReplaceDriverModal
        modalopen={replaceDriverModal}
        setModalopen={setReplaceDriverModal}
        routeid={routeId}
        tripdata={data}
        end_time={endtime}
        handleListReload={handleListReload}
      />
    </div>
  );
};

export default Tripdetails;
